<form [formGroup]="agreementForm">
    <app-form-section formGroupName="details">
        <app-form-row>
            <app-form-group>
                <div class="box">
                    <div class="form">
                        <app-form-row>
                            <app-form-group>
                                <app-risk-analysis
                                    *ngIf="riskAnalysis"
                                    [riskAnalysis]="riskAnalysis"
                                ></app-risk-analysis>
                            </app-form-group>
                        </app-form-row>
                    </div>
                </div>
            </app-form-group>
        </app-form-row>
    </app-form-section>
</form>
